import { useState, useEffect, useRef } from 'react'
import Question from 'components/question'
import { useForm, FormProvider } from "react-hook-form"
import { validationSchema } from 'validation/quiz'
import { yupResolver } from '@hookform/resolvers/yup'
import { Splide, SplideSlide } from '@splidejs/react-splide'
import '@splidejs/splide/dist/css/splide.min.css'

export default function Quiz({ quiz_type }: any) {
    const slider = useRef<any>([])
    const [quiz, setQuiz] = useState<any>(false)
    const [loading, setLoading] = useState<boolean>(false)
    const form = useForm({
        resolver: yupResolver(validationSchema(quiz)),
        mode: 'onSubmit'
    });
    const { handleSubmit, clearErrors, setError, watch, setValue, formState: { errors } } = form
    const step = watch('step') ? watch('step') : 1
    const sliderConfig = {
        options: {
            height: '100%',
            arrows: false,
            pagination: false,
            drag: false,
            start: 0
        }
    }
    const _quiz_type = quiz_type.replace(/[^a-z0-9-]/gi, '');
    const onSubmit = (data: any) => {
        if (quiz.length == step) {
            setLoading(true)
            fetch(`https://www.nutrivian.nl/wp-json/quiz/send_questions/${_quiz_type}`, {
                method: 'POST',
                body: JSON.stringify(watch()),
                headers: new Headers({ 'content-type': 'application/json' }),
            })
                .then(response => response.json())
                .then((quiz) => {
                    if (quiz.redirect_to) {
                        window.location.href = quiz.redirect_to
                    } else {
                        setError('general', { 'message': 'Something went wrong. Please try again later.' })
                    }
                })
        }

        setStep(step + 1)
        clearErrors()
    };

    const setStep = (value: number) => {
        slider.current.go(value - 1)
        setValue('step', value)
    }

    useEffect(() => {
        if (quiz == false) {
            fetch(`https://www.nutrivian.nl/wp-json/quiz/get_questions/${_quiz_type}`)
                .then(response => response.json())
                .then((quiz) => {
                    setQuiz(quiz)
                })
        }
    }, [])

    // Similar to componentDidMount and componentDidUpdate:
    useEffect(() => {
        if (Object.keys(errors).length) {
            const error = Object.keys(errors)[0]

            quiz.map((question: any) => {
                if (question.ID == error) {
                    setStep(question.step)
                }
                return
            })
        }
    }, []);

    if (!quiz || loading) {
        return (
            <div className="row h-100 text-center align-middle">
                <div className="col-12">
                    <svg version="1.1" id="L9" style={{ width: 100, height: 100 }} xmlns="http://www.w3.org/2000/svg" x="0px" y="0px"
                        viewBox="0 0 100 100">
                        <path fill="#bbc7b9" d="M73,50c0-12.7-10.3-23-23-23S27,37.3,27,50 M30.9,50c0-10.5,8.5-19.1,19.1-19.1S69.1,39.5,69.1,50">
                            <animateTransform
                                attributeName="transform"
                                attributeType="XML"
                                type="rotate"
                                dur="1s"
                                from="0 50 50"
                                to="360 50 50"
                                repeatCount="indefinite" />
                        </path>
                    </svg>
                </div>
            </div>
        )
    }

    if (quiz.length == 0) {
        return (
            <div className="row h-100 text-center">
                <div className="col-12 h-100 p-5">
                    <div className="alert alert-danger">Quiz not found</div>
                </div>
            </div>
        )
    }

    return (
        <div className="h-100">
            <div className="row h-100">
                <div className="col-12 h-100">
                    <FormProvider {...form}>
                        <form onSubmit={handleSubmit(onSubmit)}>
                            <Splide ref={slider} {...sliderConfig} className={'h-100 align-items-center justify-content-center'} >
                                {
                                    quiz.map((question: any) => {
                                        return <SplideSlide className={'h-100'} key={question.step}><Question {...question} setStep={setStep} /></SplideSlide>
                                    })
                                }
                            </Splide>
                        </form>
                    </FormProvider>
                </div>
            </div>
        </div >
    );
}
